module.exports = __webpack_public_path__ + "img/maisv.9a33d462.webp";